document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('#SiteNav');
  if (toggle && nav) {
    const setMenuOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Close' : 'Menu';
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('menu-open', open);
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      setMenuOpen(!open);
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenuOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenuOpen(false);
        toggle.focus();
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 760 && toggle.getAttribute('aria-expanded') === 'true') setMenuOpen(false);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const root = select.closest('[data-product-root]');
    const selectedOption = select.selectedOptions[0];
    const price = root?.querySelector('[data-product-price]');
    const compareAtWrapper = root?.querySelector('[data-product-compare-at-wrapper]');
    const compareAt = root?.querySelector('[data-product-compare-at]');
    if (price) price.textContent = selectedOption?.dataset.price || price.textContent;
    if (compareAtWrapper && compareAt) {
      const showCompareAt = selectedOption?.dataset.showCompareAt === 'true' && Boolean(selectedOption.dataset.compareAtPrice);
      compareAt.textContent = showCompareAt ? selectedOption.dataset.compareAtPrice : '';
      compareAtWrapper.hidden = !showCompareAt;
    }
  }));

  document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  document.querySelectorAll('[data-product-recommendations][data-url]').forEach(initProductRecommendations);

  document.querySelectorAll('[data-video-cover]').forEach((cover) => {
    cover.addEventListener('click', () => {
      const media = cover.closest('[data-home-video]');
      cover.hidden = true;
      const video = media?.querySelector('video');
      if (video) video.play().catch(() => {});
      const iframe = media?.querySelector('iframe');
      if (iframe) iframe.focus();
    });
  });

  document.querySelectorAll('[data-contact-pending]').forEach((form) => {
    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Send Message — Awaiting Verification';
    }
    form.addEventListener('submit', (event) => event.preventDefault());
  });
});

async function initProductRecommendations(section) {
  try {
    const response = await fetch(section.dataset.url);
    if (!response.ok) return;
    const html = document.createElement('div');
    html.innerHTML = await response.text();
    const replacement = html.querySelector('[data-product-recommendations]');
    if (replacement && replacement.querySelector('.product-card')) {
      replacement.querySelectorAll('a[href^="/products/"], a[href^="/collections/"]').forEach((link) => {
        link.href = link.getAttribute('href');
      });
      section.replaceWith(replacement);
    }
  } catch (_) {
    // Product recommendations are enhancement-only; the empty architecture stays collapsed.
  }
}

function initGallery(gallery) {
  const stage = gallery.querySelector('[data-gallery-stage]');
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const counter = gallery.querySelector('[data-gallery-counter]');
  const viewer = gallery.querySelector('[data-image-viewer]');
  const viewerImage = gallery.querySelector('[data-viewer-image]');
  const viewerCounter = gallery.querySelector('[data-viewer-counter]');
  const canvas = gallery.querySelector('[data-viewer-canvas]');
  if (!stage || !slides.length || !viewer || !viewerImage || !canvas) return;
  const imageIndexes = slides.map((slide, slideIndex) => slide.dataset.mediaType === 'image' ? slideIndex : -1).filter((slideIndex) => slideIndex >= 0);

  let index = 0;
  let scale = 1;
  let translateX = 0;
  let translateY = 0;
  let savedScroll = 0;
  let startX = 0;
  let startY = 0;
  let startDistance = 0;
  let startScale = 1;

  const update = (next, smooth = true) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => { if (slideIndex !== index) slide.querySelector('video')?.pause(); });
    stage.scrollTo({ left: index * stage.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    if (!viewer.hidden) showViewerImage();
  };

  const resetZoom = () => { scale = 1; translateX = 0; translateY = 0; applyTransform(); };
  const applyTransform = () => { viewerImage.style.transform = `translate3d(${translateX}px,${translateY}px,0) scale(${scale})`; };
  const showViewerImage = () => {
    const source = slides[index].querySelector('img');
    if (!source) return;
    const candidates = (source.getAttribute('srcset') || '').split(',').map(item => item.trim().split(/\s+/)).filter(item => item[0]);
    candidates.sort((a,b) => parseInt(b[1] || '0',10) - parseInt(a[1] || '0',10));
    viewerImage.src = candidates[0]?.[0] || source.currentSrc || source.src;
    viewerImage.alt = source.alt;
    if (viewerCounter) viewerCounter.textContent = `${index + 1} / ${slides.length}`;
    resetZoom();
  };
  const moveViewer = (direction) => {
    const currentImageIndex = imageIndexes.indexOf(index);
    const nextImageIndex = (currentImageIndex + direction + imageIndexes.length) % imageIndexes.length;
    index = imageIndexes[nextImageIndex];
    showViewerImage();
  };
  const openViewer = (next) => {
    index = next;
    savedScroll = window.scrollY;
    viewer.hidden = false;
    document.body.style.top = `-${savedScroll}px`;
    document.body.classList.add('viewer-open');
    showViewerImage();
    gallery.querySelector('[data-viewer-close]')?.focus();
  };
  const closeViewer = () => {
    viewer.hidden = true;
    document.body.classList.remove('viewer-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScroll);
    slides[index].focus({ preventScroll: true });
  };

  stage.addEventListener('scroll', () => {
    const next = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
    if (next !== index) { index = next; thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index)); if (counter) counter.textContent = `${index + 1} / ${slides.length}`; }
  }, { passive: true });
  slides.forEach((slide, slideIndex) => { if (slide.dataset.mediaType === 'image') slide.addEventListener('click', () => openViewer(slideIndex)); });
  thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => update(thumbIndex)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => update(index - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => update(index + 1));
  gallery.querySelector('[data-viewer-prev]')?.addEventListener('click', () => moveViewer(-1));
  gallery.querySelector('[data-viewer-next]')?.addEventListener('click', () => moveViewer(1));
  gallery.querySelector('[data-viewer-close]')?.addEventListener('click', closeViewer);

  const touchDistance = (touches) => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
  canvas.addEventListener('touchstart', (event) => {
    startX = event.touches[0].clientX; startY = event.touches[0].clientY;
    if (event.touches.length > 1) { startDistance = touchDistance(event.touches); startScale = scale; }
  }, { passive: true });
  canvas.addEventListener('touchmove', (event) => {
    if (event.touches.length > 1 && startDistance) { scale = Math.min(5, Math.max(1, startScale * touchDistance(event.touches) / startDistance)); applyTransform(); }
    else if (scale > 1) { translateX += event.touches[0].clientX - startX; translateY += event.touches[0].clientY - startY; startX = event.touches[0].clientX; startY = event.touches[0].clientY; applyTransform(); }
  }, { passive: true });
  canvas.addEventListener('touchend', (event) => {
    if (scale === 1 && event.changedTouches.length) { const dx = event.changedTouches[0].clientX - startX; const dy = event.changedTouches[0].clientY - startY; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) moveViewer(dx < 0 ? 1 : -1); }
  });
  canvas.addEventListener('dblclick', () => { scale = scale > 1 ? 1 : 2.5; translateX = 0; translateY = 0; applyTransform(); });
  document.addEventListener('keydown', (event) => {
    if (viewer.hidden) return;
    if (event.key === 'Escape') closeViewer();
    if (event.key === 'ArrowLeft') moveViewer(-1);
    if (event.key === 'ArrowRight') moveViewer(1);
  });
}
